import { render, staticRenderFns } from "./ViewMethodDataExtractionStudyCharacteristics.vue?vue&type=template&id=45e34924&scoped=true"
import script from "./ViewMethodDataExtractionStudyCharacteristics.vue?vue&type=script&lang=js"
export * from "./ViewMethodDataExtractionStudyCharacteristics.vue?vue&type=script&lang=js"
import style0 from "./ViewMethodDataExtractionStudyCharacteristics.vue?vue&type=style&index=0&id=45e34924&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e34924",
  null
  
)

export default component.exports